import clickableIconTemplate from './clickableIcon.html';

const clickableIcon = () => ({
    template: clickableIconTemplate,
    scope: {
        subtitle: '=',
        clickCallback: '&?',
        palette: '=',
        type: '<',
        currentBoxType: '=',
    },
    controller: 'ClickableIconCtrl',
    controllerAs: 'clickableIcon',
    bindToController: true
});

export default clickableIcon;